module.exports = __webpack_public_path__ + "static/media/208.c5b7eda4.svg";